import { html } from './env';

/*
  Révélation de la page une fois la police (préchargée) prête : le CSS masque le
  body tant que `html.fonts-ready` est absent (voir src/css/base/_index.css).
  Au plus tard après 1,5 s, pour ne jamais bloquer l'affichage.
*/

let fontsReady: Promise<void> | undefined;

export function revealFonts(): Promise<void> {
  if (fontsReady) return fontsReady;

  const reveal = () => {
    html.classList.add('fonts-ready');
  };

  if (!('fonts' in document)) {
    reveal();
    fontsReady = Promise.resolve();
    return fontsReady;
  }

  fontsReady = Promise.race([
    Promise.all([
      document.fonts.load('700 1em "Mona Sans"'),
      document.fonts.load('400 1em "Mona Sans"'),
    ]),
    new Promise((resolve) => {
      window.setTimeout(resolve, 1500);
    }),
  ]).then(reveal, reveal);

  return fontsReady;
}
